import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import amitimLogo from "../../assets/images/Amitim_Logo_Slogan.svg";
import amitimPdf from "../../assets/pdf/sachir_shimush.pdf";
import BarakeGuidePdf from "../../assets/pdf/BarakeGuide.pdf";
import BarakeGuideArabicPdf from "../../assets/pdf/BarakeGuideArabic.pdf";


import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import "./Footer.scss";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { screenSzie } from "../../utils/main";

const contactUrl = "https://www.amitim.com/שירות-לקוחות/צור קשר";

const accessabilityUrl = "https://www.amitim.com/אודותינו/נגישות";


const Footer = () => {
  const { t, i18n } = useTranslation("common");
  const location = useLocation();
  const hideFooter = () =>
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/privacy-questions";

  const getTermsOfUse = () => {
    return amitimPdf;    
  };

  const { width } = useWindowDimensions();
  const phone = (screenSzie.smallPhone <width&& width<= screenSzie.phone); 
  const isSmallPhone = ( width<= screenSzie.smallPhone); 


  const getAccessability = () => {
    if (i18n.language === "he") return accessabilityUrl;
    return accessabilityUrl;
  };

  // const getGuide = () => {
  //   if (i18n.language === "he") return BarakeGuidePdf;
  //   return BarakeGuideArabicPdf;
  // };


  useEffect(() => {}, [location]);

  return (
     <footer className={hideFooter() ? "min-footer" : ""} >
      {hideFooter() ? null : 
            <div className="right-side-footer">
            <img src={amitimLogo}   width={phone?95:211} alt={t("header.imgalt")} className="amitim-footer-logo" />
            {/* <div className="footer-main-text-wrapper">
              <span className="main-right-footer-text">{t("general.amitim")}</span>
              <span className="sub-right-footer-text">
                {t("Footer.oldPension")}
              </span>
            </div> */}
            <div className="horizon-divider"></div>
            <div className="left-side-footer">
              <span className="main-left-footer-text">{t("Footer.moked")}</span>
              <span className="mid-left-footer-text">{t("Footer.mokedHours")}</span>
              <span className="sub-left-footer-text">{t("Footer.mokedDays")}</span>
            </div>
          </div>
          
          }
            {hideFooter() ? <div className="inner-footer" role={"contentinfo"}>
        <div className="inner-footer-text-wrapper">
          <a
            className="first-inner-footer-text"
            onClick={() => window.open(getTermsOfUse())}
            onKeyPress={(event) =>
              isEnterPress(event) && window.open(getTermsOfUse())
            }
            tabIndex={0}         
            target="_blank"
          >
            {t("Footer.terms")}
          </a>
          <a className="last-inner-footer-text"
            // onClick={() => window.open(getGuide())}
            // onKeyPress={(event) =>
            //   isEnterPress(event) && window.open(getGuide())
            // }
            tabIndex={0}        
            target="_blank"
          >
            {t("Footer.guide")}

          </a>
          <a className="last-inner-footer-text"
            href={contactUrl}
            target="_blank"
          >
            {t("Footer.contact")}
          </a>
          <a
            className="last-inner-footer-text"
            title={t("htmltitle.accessabilityLink")}
            href={getAccessability()}
            target="_blank"
          >
            {t("Footer.accessability")}
          </a>
        </div>
      </div> : 
      <div className="inner-footer">
        <div className="inner-footer-text-wrapper">
          <a
            className="first-inner-footer-text"
            onClick={() => window.open(getTermsOfUse())}
            onKeyPress={(event) =>
              isEnterPress(event) && window.open(getTermsOfUse())
            }
            tabIndex={0}         
            target="_blank"
          >
            {t("Footer.terms")}
          </a>
          <a className="last-inner-footer-text"
            // onClick={() => window.open(getGuide())}
            // onKeyPress={(event) =>
            //   isEnterPress(event) && window.open(getGuide())
            // }
            tabIndex={0}        
            target="_blank"
          >
            {t("Footer.guide")}

          </a>
          <a className="last-inner-footer-text"
            href={contactUrl}
            target="_blank"
          >
            {t("Footer.contact")}
          </a>
          <a
            className="last-inner-footer-text"
            title={t("htmltitle.accessabilityLink")}
            href={getAccessability()}
            target="_blank"
          >
            {t("Footer.accessability")}
          </a>
        </div>
      </div>}
     
    </footer>
   )
     

};

export default Footer;

 
 